import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { MainService } from '../../services/optimizer-service/optimizer.service';
import { Trip } from '../../DataStructures/Trip/Trip';
import { CONSTANTS } from '../../utilities/Constants';
import { CompanyLocationSelectorComponent, CompanyLocationSelectorOptions } from '../../shared/company-location-selector/company-location-selector.component';

@Component({
  selector: 'app-destination-picker',
  templateUrl: './destination-picker.component.html',
  styleUrls: ['./destination-picker.component.css']
})
export class DestinationPickerComponent implements OnInit {

  trip: Trip;
  @ViewChild('companySelect') company : CompanyLocationSelectorComponent
  destinations = [];
  selectedDestination = -1;
    options: CompanyLocationSelectorOptions = {
      class: 'form-control',
      style: { 'margin-bottom': '10px', 'width:': '100%' }
    }
  constructor(public dialogRef: MatDialogRef<DestinationPickerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private main: MainService) {
    this.trip = data;
    this.selectedDestination = this.trip.destinationid;
  }


  save() {
    var destination = this.destinations.find(x => x.id == this.selectedDestination);
    if (destination) {
      this.main.updateDestination({
        id:this.trip.id,
        companyid:this.company.companyid,
        locationid:this.company.locationid,
        company:this.company.selectedCompany,
        location:this.company.selectedLocation,
        destinationid:destination.id,
        destinationName:destination.destination
      }).then(() =>{
        this.dialogRef.close(true);
      }).catch(e =>{
        console.log(e);
        this.dialogRef.close(false);
      })
    }
  }

  onCompany(event){
    this.destinations = [];
  }

  onLocation(event){
    this.destinations = [];
    this.loadDestinations();
  }

  onLoaded(){
    this.company.onCompanySelected(this.trip.companyid);
    this.company.onLocationSelected(this.trip.locationid);
    this.loadDestinations();
  }

  getLabel(){
    if(Trip.getPickupTypeCode(this.trip) == CONSTANTS.PICKUP_TYPE_POINT_TO_POINT && this.trip.source.centralPoint){
        return "Change Starting Point";
    }
    return "Change Destination";
  }
  ngOnInit() {
  }

  loadDestinations(){
    var rateType = "d2d";
    if (Trip.getPickupTypeCode(this.trip) == CONSTANTS.PICKUP_TYPE_POINT_TO_POINT) {
      rateType = "p2p";
    }
    this.main.getFlatrateDestinations(this.company.companyid, this.company.locationid, rateType, this.trip.source.centralPoint).then((destinations) => {      
      this.destinations = destinations.data;
    }).catch(e => {
      console.log(e);
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/admin-dashboard/destination-picker/destination-picker.component.ts